import { render } from "./CustomObjectItem.vue?vue&type=template&id=02230066"
import script from "./CustomObjectItem.vue?vue&type=script&lang=js"
export * from "./CustomObjectItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__